// src/components/Dashboard/FilterBar.js
import React from 'react';
import './FilterBar.css';

const FilterBar = ({ filters, setFilters, onApply, isLoading }) => {

  // Manejador genérico para actualizar el estado de los filtros
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters(prevFilters => ({
      ...prevFilters,
      [name]: value
    }));
  };

  return (
    <div className="filter-bar card shadow-sm mb-4">
      <div className="card-body">
        <div className="row g-3 align-items-end">

          {/* --- Filtro de Rango de Fechas --- */}
          <div className="col-md-4">
            <label htmlFor="dateRange" className="form-label">Rango de Fechas</label>
            <select
              id="dateRange"
              name="dateRange"
              className="form-select"
              value={filters.dateRange}
              onChange={handleChange}
              disabled={isLoading}
            >
              <option value="30d">Últimos 30 días</option>
              <option value="90d">Últimos 90 días</option>
              <option value="mesActual">Este Mes</option>
              <option value="mesAnterior">Mes Anterior</option>
              <option value="trimestreActual">Este Trimestre</option>
            </select>
          </div>

          {/* --- Filtro de Proveedor --- */}
          <div className="col-md-5">
            <label htmlFor="provider" className="form-label">Proveedor</label>
            <input
              type="text"
              id="provider"
              name="provider"
              className="form-control"
              placeholder="Buscar por nombre o código de proveedor..."
              value={filters.provider}
              onChange={handleChange}
              disabled={isLoading}
            />
            {/* NOTA: Más adelante, aquí podríamos instanciar un 
                componente <Autocomplete> para buscar proveedores en SAP */}
          </div>

          {/* --- Botón de Aplicar --- */}
          <div className="col-md-3">
            <button 
              className="btn btn-primary w-100" 
              onClick={onApply} 
              disabled={isLoading}
            >
              {isLoading ? (
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              ) : (
                <><i className="bi bi-funnel-fill me-2"></i> Aplicar Filtros</>
              )}
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default FilterBar;